/*jshint browserify: true */
'use strict';

/**
 * Thanks to the viewport, the PDF may be scaled, so 1 pixel in viewport may not be 1 pixel in PDF.
 * Also, PDF 0,0 co-ord is bottom-left, but viewport 0,0 co-ord is top-left.
 *
 * @return {Object} Containing x and y properties in PDF coordinates.
 */
function translateViewportPositionToPdfPosition(pdfViewport, viewportX, viewportY) {
    var translatedX = viewportX / pdfViewport.scale;
    if (translatedX > (pdfViewport.width / pdfViewport.scale)) {
        translatedX = (pdfViewport.width / pdfViewport.scale);
    }

    var translatedY = (pdfViewport.height - viewportY) / pdfViewport.scale;

    return {
        x: translatedX,
        y: translatedY
    };
}

module.exports = translateViewportPositionToPdfPosition;